import { ScheduleModel } from 'app/views/devices/models/schedule.model';

export class DevicesGroupModel {
    public id: string;
    public name: string;
    public creationDate: any;
    public modificationDate: any;

    constructor(
        public owners: object = {},
        public schedule?: ScheduleModel
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/models/devicesGroup.model.ts